module.exports = __webpack_public_path__ + "static/media/maynilad.e015450b.png";